import { render, staticRenderFns } from "./ResetAppointment.vue?vue&type=template&id=b848dd8e&"
import script from "./ResetAppointment.vue?vue&type=script&lang=ts&"
export * from "./ResetAppointment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports